import './index.less'
import React from 'react'
import { useState } from 'react'
console.log(React)
export default function Text(props) {
  const [ifon, setIfon] = useState({
    text: props.text
  })

  return (<div className='Text'>
    <textarea className='Text_text' placeholder='请输入' value={ifon.text} onChange={(e) => {
      setIfon({
        text: e.target.value
      })
      props.setText && props.setText(e.target.value)
    }}></textarea>
    <div className='Text_tips'>
      1/10
    </div>
  </div>)
}
